import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CodeTypeModel }            from '../core/models/code-type';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyQuoteModel }        from '../companies/models/company.quote';
import { CompanyService }           from '../companies/company.service';
import { MessagesService }          from '../messages/messages.service';
import { RepcoService }            from './repco.service';
import { RepcoSettingsModel }      from './typings/repco.settings';
import { VendorModel }             from '../vendors/models/vendor';
import { VendorSearchService }     from '../vendors/vendor.search.service';

@Component({
  selector   : 'repco-settings',
  template: require('./repco.settings.component.html')
})
export class RepcoSettingsComponent implements OnInit {
  @Input() companySettings: CompanyIntegrationsModel;
  @Input() quote          : CompanyQuoteModel;
  @Input() session        : any;
  @Input() settings       : RepcoSettingsModel;

  confirmPassword : string;
  priceOptions    : Array<CodeTypeModel> = [
    {
      code          : 'NOTHING',
      language_label: 'JS_SPACE.REPCO.DONT_CHANGE_THE_PRICE'
    },
    {
      code          : 'DIFFERENT',
      language_label: 'JS_SPACE.REPCO.PRICE_IS_DIFFERENT'
    },
    {
      code          : 'HIGHER',
      language_label: 'JS_SPACE.REPCO.PRICE_HIGHER'
    },
    {
      code          : 'ALL',
      language_label: 'JS_SPACE.REPCO.ALWAYS_USE_REPCO_PRICE'
    }
  ];
  repcoLink       : string = '<a href="//repco.com.au" target="_blank" rel="noopener noreferrer">Repco</a>';
  title           : string = this.repcoService.title;
  vendor          : VendorModel;

  constructor (
    private companyService     : CompanyService,
    private messagesService    : MessagesService,
    private repcoService       : RepcoService,
    private router             : UIRouter,
    private translateService   : TranslateService,
    private vendorSearchService: VendorSearchService
  ) {}

  getAutoDownloadContactEmail () : string {
    return this.companyService.country('australia')
      ? 'online@repco.com.au'
      : 'online@repco.com.nz';
  }

  getVendor () : void {
    this.vendorSearchService.get(this.settings.repco_vendor_id)
    .then(( vendor : VendorModel ) => {
      this.vendor = vendor;
    })
    .catch(() => null);
  }

  handleVendorChange ( vendor : string | VendorModel ) : void {
    if (!vendor) {
      this.settings.repco_vendor_id = '';

      if (this.settings.repco_settings) {
        this.settings.repco_settings.repco_vendor_name = '';
      }
    }
  }

  hasPasswordChanged () : boolean {
    return !!this.settings.repco_password;
  }

  newVendor () : void {
    this.vendorSearchService.quickAdd()
    .then(( vendor : VendorModel ) => {
      this.vendor = vendor;
      this.setVendor(vendor);
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', {
        name: this.title
      }), 'success');
    })
    .catch(() => null);
  }

  ngOnInit () : void {
    if (this.settings.repco_vendor_id) {
      this.getVendor();
    }
  }

  purchase () : void {
    this.repcoService.purchase()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PURCHASED_INTEGRATION', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  remove () : void {
    this.repcoService.remove()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  save () : void {
    this.repcoService.save(this.settings, this.companySettings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  setVendor ( vendor : VendorModel ) : void {
    this.settings.repco_vendor_id = vendor.id;

    if (!this.settings.repco_settings) {
      this.settings.repco_settings = {};
    }

    this.settings.repco_settings.repco_vendor_name = vendor.company_name;
  }
}
